import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c(VIcon,{staticClass:"mr-n10 mt-n2px",attrs:{"color":"#0d4663","size":"60"}},[_vm._v("mdi-arrow-left-bold")]),_c('div',{attrs:{"id":"retangulo"}},[_vm._v("\n    MAIS BAIXO MENOR É A IMPORTÂNCIA\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }